var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsMinimize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.4,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#757B83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M28.29 2.12L31.17 5H18c-.55 0-1 .45-1 1s.45 1 1 1h13.17l-2.88 2.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L29.7.7c-.39-.39-1.02-.39-1.41 0-.38.39-.39 1.03 0 1.42zM36 1v10c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1z",
    transform: "translate(-96 -28) translate(96 28) matrix(-1 0 0 1 55 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 8,
    fontWeight: 500,
    transform: "translate(-96 -28) translate(96 28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "MINIMIZE")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMinimize);
export default __webpack_public_path__ + "static/media/icons-minimize.0825ad0876b00525a714cd312e2e49ec.svg";
export { ForwardRef as ReactComponent };